module.exports = __webpack_public_path__ + "static/media/MarkerApiMerahVerified.3fe220fc.png";